<template>
    <div class="generator_popup_container" @click.self="closePopup">
    <!-- <div class="popup_overlay"> -->
        <div class="generator_popup">
            <div class="bkrdSymGenerator no_border">
                {{ v$.form.barcode_value.regex }}
                <h4 class="popup_title">
                    Generate {{ selectedBarcode.title }} barcode
                    <button class="close" @click="closePopup"><svg viewBox="0 0 24 24"><use xlink:href="#close"></use></svg></button>
                </h4>
                <div class="resRow">
                    <div class="resBox">
                        <div class="generator_line for_validation">
                            <h4 for="barcode_value">Barcode Content</h4>
                            <div>
                                <textarea id="barcode_value" name="barcode_value" v-model="v$.form.barcode_value.$model" :class="{ textarea_input: true, 'not-valid': v$.form.barcode_value.$errors.length }" placeholder="Barcode value"></textarea>
                                <div class="form-message" v-for="(error, index) of v$.form.barcode_value.$errors":key="index">
                                    <div>{{ error.$message  }}</div>
                                </div>
                                <p class="sm_msg">
                                    Example: {{ selectedBarcode.example }}
                                </p>                            
                            </div>
                        </div>
                        <div class="generator_line">
                            <button @click.prevent="submit(false)" class="button link red ">Generate<svg viewBox="0 0 20 20"><use xlink:href="#arrow_right"></use></svg></button>
                        </div>
                    </div>

                    <div v-if="selectedBarcode.data_sym_type" class="resBox info_line_wrap">
                        <div v-if="selectedBarcode.char_set" class="info_line">
                            <div class="info">
                                <svg viewBox="0 0 20 20"><use xlink:href="#info"></use></svg>
                            </div>
                            <div class="txt">
                                <h4>Character Set:</h4>
                                <div class="info_desc">
                                    <div class="charset">{{selectedBarcode.char_set}}</div>
                                </div>
                            </div>
                        </div>
                        <div v-if="selectedBarcode.length" class="info_line">
                            <div class="info">
                                <svg viewBox="0 0 20 20"><use xlink:href="#info"></use></svg>
                            </div>
                            <div class="txt">
                                <h4>Length:</h4>
                                <div class="info_desc">
                                    <div class="length">{{selectedBarcode.length}}</div>
                                </div>
                            </div>
                        </div>
                        <div v-if="selectedBarcode.category" class="info_line">
                            <div class="info">
                                <svg viewBox="0 0 20 20"><use xlink:href="#info"></use></svg>
                            </div>
                            <div class="txt">
                                <h4>Category:</h4>
                                <div class="info_desc">
                                    <div class="category">{{selectedBarcode.category}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="resRow">
                    
                    <div class="resBox" :class="{centered:!generatedBarcodeUrl}">
                        <div class="resultImageWrapper">
                            <img v-if="generatedBarcodeUrl" :src="generatedBarcodeUrl" alt="barcode" />
                            <img v-else :src="img_path + selectedBarcode.img" class="default" alt="barcode" />
                        </div>
                    </div>

                    <transition>
                        <div v-if="generatedBarcodeUrl" class="resBox">
                            <div class="radioBtns">
                                <h4>Format:</h4>
                                <div class="form_radio_btn format">
                                    <label :class="{ radio_selected: form.format == 'PNG' }">
                                        <svg viewBox="0 0 48 48"><path d="M4 21.8125H8.47917V26.1875H4V21.8125ZM21.8125 8.47917H26.1875V17.3333H21.8125V8.47917ZM17.3333 21.8125H26.1875V30.6667H21.8125V26.1875H17.3333V21.8125ZM30.6667 21.8125H35.1458V26.1875H39.5208V21.8125H44V26.1875H39.5208V30.6667H44V39.5208H39.5208V44H35.1458V39.5208H26.1875V44H21.8125V35.1458H30.6667V30.6667H35.1458V26.1875H30.6667V21.8125ZM39.5208 39.5208V30.6667H35.1458V39.5208H39.5208ZM30.6667 4H44V17.3333H30.6667V4ZM35.1458 8.47917V12.8542H39.5208V8.47917H35.1458ZM4 4H17.3333V17.3333H4V4ZM8.47917 8.47917V12.8542H12.8542V8.47917H8.47917ZM4 30.6667H17.3333V44H4V30.6667ZM8.47917 35.1458V39.5208H12.8542V35.1458H8.47917Z" fill="var(--fill-color)"></path></svg>
                                        PNG
                                        <input v-model="form.format" type="radio" name="format" value="PNG" checked="checked" />
                                    </label>
                                    <label :class="{ radio_selected: form.format == 'SVG' }">
                                        <svg viewBox="0 0 48 48"><path d="M35.4286 4C36.2024 4 36.8571 4.26786 37.3929 4.80357C37.9286 5.33929 38.1964 6.02381 38.1964 6.85714C38.1964 7.63095 37.9286 8.28571 37.3929 8.82143C36.8571 9.35714 36.2024 9.65476 35.4286 9.71429C34.9524 9.71429 34.5357 9.59524 34.1786 9.35714L27.125 16.4107L27.75 17.3036C29.8929 16.1131 32.1548 15.1905 34.5357 14.5357C36.9167 13.8214 39.4167 13.4643 42.0357 13.4643L44 13.5536V17.3929L42.0357 17.3036C39.5952 17.3036 37.244 17.6607 34.9821 18.375C32.7202 19.0298 30.6369 19.9821 28.7321 21.2321C28.6726 23.3155 27.9286 25.0714 26.5 26.5C25.0714 27.9286 23.3155 28.6726 21.2321 28.7321C19.9821 30.6369 19 32.7202 18.2857 34.9821C17.631 37.244 17.3036 39.5952 17.3036 42.0357L17.3929 44H13.5536L13.4643 42.0357C13.4643 39.4167 13.7917 36.9167 14.4464 34.5357C15.1607 32.1548 16.1131 29.8929 17.3036 27.75L16.4107 27.125L9.35714 34.1786C9.59524 34.5357 9.71429 34.9524 9.71429 35.4286C9.65476 36.2024 9.35714 36.8571 8.82143 37.3929C8.28571 37.9286 7.60119 38.1964 6.76786 38.1964C5.99405 38.1964 5.33929 37.9286 4.80357 37.3929C4.26786 36.8571 4 36.2024 4 35.4286C4 34.5952 4.26786 33.9107 4.80357 33.375C5.33929 32.8393 6.02381 32.5714 6.85714 32.5714C7.27381 32.5714 7.69048 32.6607 8.10714 32.8393L15.0714 25.7857C14.0595 24.4762 13.5238 22.9286 13.4643 21.1429C13.5238 18.9405 14.2679 17.125 15.6964 15.6964C17.125 14.2679 18.9405 13.5238 21.1429 13.4643C22.9286 13.5238 24.4762 14.0595 25.7857 15.0714L32.8393 8.10714C32.6607 7.69048 32.5714 7.27381 32.5714 6.85714C32.5714 6.02381 32.8393 5.33929 33.375 4.80357C33.9107 4.26786 34.5952 4 35.4286 4ZM21.1429 17.3036C20.0714 17.3036 19.1488 17.6905 18.375 18.4643C17.6607 19.1786 17.3036 20.0714 17.3036 21.1429C17.3036 22.2143 17.6607 23.1071 18.375 23.8214C19.1488 24.5357 20.0714 24.8929 21.1429 24.8929C22.2143 24.8929 23.1071 24.5357 23.8214 23.8214C24.5357 23.1071 24.8929 22.2143 24.8929 21.1429C24.8929 20.0714 24.5357 19.1786 23.8214 18.4643C23.1071 17.6905 22.2143 17.3036 21.1429 17.3036Z" fill="var(--fill-color)"></path></svg>
                                        SVG
                                        <input v-model="form.format" type="radio" name="format" value="SVG" />
                                    </label>
                                </div>
                            </div>
                            <div class="radioBtns">
                                <h4>Barcode Resolution:</h4>
                                <div class="form_radio_btn resolution">
                                    <label :class="{ radio_selected: form.resulution == 'small' }">
                                        Small
                                        <input v-model="form.resulution" type="radio" name="resulution" value="small" checked="checked" />
                                    </label>
                                    <label :class="{ radio_selected: form.resulution == 'medium' }">
                                        Medium
                                        <input v-model="form.resulution" type="radio" name="resulution" value="medium" />
                                    </label>
                                    <label :class="{ radio_selected: form.resulution == 'large' }">
                                        Large
                                        <input v-model="form.resulution" type="radio" name="resulution" value="large" />
                                    </label>
                                </div>
                            </div>
                            <div class="generator_line">
                                <button @click.prevent="download" class="button link red icon-first">
                                    <svg width="25" height="25" viewBox="0 0 25 25" fill="none"><mask id="mask0_7665_3754" maskUnits="userSpaceOnUse" x="0" y="0" width="25" height="25" style="mask-type: alpha;"><rect x="0.874023" y="0.6875" width="24" height="24" fill="#D9D9D9"></rect></mask><g mask="url(#mask0_7665_3754)"><path d="M12.124 13.4336V6.76807C10.8639 6.91173 9.84044 7.49057 9.05377 8.50457C8.26727 9.51873 7.87402 10.5796 7.87402 11.6873H7.37402C6.40736 11.6873 5.58236 12.029 4.89902 12.7123C4.21569 13.3956 3.87402 14.2206 3.87402 15.1873C3.87402 16.154 4.21569 16.979 4.89902 17.6623C5.58236 18.3457 6.40736 18.6873 7.37402 18.6873H19.374C20.074 18.6873 20.6657 18.4457 21.149 17.9623C21.6324 17.479 21.874 16.8873 21.874 16.1873C21.874 15.4873 21.6324 14.8957 21.149 14.4123C20.6657 13.929 20.074 13.6873 19.374 13.6873H17.874V11.6873C17.874 10.8745 17.6907 10.1222 17.324 9.43057C16.9574 8.7389 16.474 8.15782 15.874 7.68732V5.92957C16.9599 6.4809 17.8147 7.27448 18.4385 8.31032C19.0622 9.34632 19.374 10.472 19.374 11.6873V12.1873H19.6818C20.7356 12.2693 21.6144 12.6931 22.3183 13.4586C23.0221 14.2239 23.374 15.1335 23.374 16.1873C23.374 17.3027 22.9862 18.2482 22.2105 19.0238C21.4349 19.7995 20.4894 20.1873 19.374 20.1873H7.37402C5.99202 20.1873 4.81319 19.7072 3.83752 18.7468C2.86186 17.7867 2.37402 16.6156 2.37402 15.2336C2.37402 14.0104 2.76569 12.9226 3.54902 11.9701C4.33236 11.0174 5.33169 10.4539 6.54702 10.2796C6.77269 9.0604 7.43777 7.9204 8.54227 6.85957C9.64677 5.79857 10.8407 5.26807 12.124 5.26807C12.533 5.26807 12.8853 5.41582 13.1808 5.71132C13.4763 6.00682 13.624 6.35907 13.624 6.76807V13.4336L14.9278 12.1451C15.0663 12.0066 15.2378 11.9357 15.4423 11.9326C15.6468 11.9294 15.8266 12.0053 15.9818 12.1603C16.1266 12.3053 16.199 12.481 16.199 12.6873C16.199 12.8937 16.1266 13.0693 15.9818 13.2143L13.5068 15.6893C13.3259 15.87 13.115 15.9603 12.874 15.9603C12.633 15.9603 12.4221 15.87 12.2413 15.6893L9.76627 13.2143C9.62794 13.0758 9.55461 12.9043 9.54627 12.6998C9.53794 12.4953 9.61127 12.3155 9.76627 12.1603C9.91127 12.0155 10.0844 11.9405 10.2855 11.9353C10.4869 11.9303 10.6651 12.0002 10.8203 12.1451L12.124 13.4336Z" fill="#E52E4C"></path></g></svg>
                                    Download Barcode
                                </button>
                            </div>
                        </div>
                    </transition>
                </div>
            </div>
        </div>
    <!-- </div> -->
    </div>
</template>

<script>
import { WEB_USERNAME, WEB_PASS, ENV, HOME_URL } from "../constants/envrionment";
import { useReCaptcha } from 'vue-recaptcha-v3'
import useVuelidate from '@vuelidate/core'
import { required, helpers, regex  } from '@vuelidate/validators'
import defaultBarcodeImage from "../assets/img/barcode.png"

export default {
    props: ['selectedBarcode'],
    data() {
        return {
            form: {
                recaptcha_token: "",
                barcode_type: "",
                format: "PNG",
                resulution: "large",
                barcode_value: "",
            },
            home_url: HOME_URL,
            generatedBarcodeUrl: '',
            img_path: HOME_URL + "themes/barkoder/img/",

        };
    },
    setup() {
        return { v$: useVuelidate(), 'recaptcha': useReCaptcha() }
    },
    validations() {

        const regex = new RegExp(this.selectedBarcode.regex)

        const validCharSet = (value) => !helpers.req(value) || regex.test(value)

        return {
            form: {
                barcode_value: {
                    required: helpers.withMessage('Please enter value', required),
                    validCharSet: helpers.withMessage('Invalid Character set', validCharSet),
                },
            },
        }
    },
    watch: {
        'form.barcode_value': function (newVal, oldVal) {
            if (!newVal) {
                this.generatedBarcodeUrl = ''
            }
        },
    },
    computed: {
        barcodeDefaultBarcodeImage: function () {

            return defaultBarcodeImage
        },
        barcode_type_options: function () {

            let res = {};

            for (const [i, o] of Object.entries(this.symbologies_info)) {
                for (const [k, s] of Object.entries(o)) {
                    res[k] = s.name
                }
            }

            return res;
        },
        barcode_text_type_options: function () {

            let res = {};

            for (const [i, o] of Object.entries(this.symbologies_info)) {
                for (const [k, s] of Object.entries(o)) {
                    res[s.name] = {
                        'type': i,
                        'sym': k
                    }
                }
            }
            return res;
        },
    },
    methods: {
        closePopup() {
            this.$emit('closePopup');
        },
        async generateRecaptchaToken() {
            const { executeRecaptcha, recaptchaLoaded } = this.recaptcha

            await recaptchaLoaded()

            let recaptcha_token = await executeRecaptcha('generate')
            this.form['recaptcha_token'] = encodeURIComponent(recaptcha_token)
        },

        download() {
            this.submit(true)
        },
        async submit(download) {

            let self = this,
                downloadImage = false;

            if (typeof download != 'undefined' && download) {
                downloadImage = true;
            }
            const result = await this.v$.$validate()
            if (!result) {
                return
            }
            try {

                let post_params = {
                    recaptcha_token: self.form.recaptcha_token,
                    barcode_type: self.form.barcode_type,
                    format: self.form.format,
                    resulution: self.form.resulution,
                    barcode_value: self.form.barcode_value,
                }

                if (downloadImage) {
                    post_params['download'] = true;
                }
                // POST request using fetch with error handling
                var requestOptions = {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(post_params)
                };
                if (ENV == 'dev') {
                    requestOptions['headers']['authorization'] = "Basic " + btoa(WEB_USERNAME + ":" + WEB_PASS)
                }

                fetch(this.home_url + 'barcodeGenerators/generate_barcode', requestOptions)
                    .then(async response => {
                        const data = await response.json();
                        if (data.status) {
                            if (downloadImage) {
                                window.location.href = this.home_url + 'barcodeGenerators/download_barcode/' + data.file_name;
                            }
                            else {
                                self.generatedBarcodeUrl = data.file_url
                            }
                        }
                        else {
                            $.append_notification('error', data.message);
                        }
                    })
                    .catch(error => {
                        this.errorMessage = error
                        console.error('There was an error!', error);
                    });

            } catch (err) {
                console.log(err);
            }
            this.generateRecaptchaToken()
        },
        isObject: function (value) {
            return value && typeof value === 'object' && value.constructor === Object;
        },
        objectLength: function (obj) {
            return (this.isObject(obj)) ? Object.keys(obj).length : 0;
        }
    },
    mounted: function () {

        let self = this;

        if (this.objectLength(this.selectedBarcode)) {
            this.form.barcode_type = this.selectedBarcode.data_sym_type
            this.form.barcode_value = this.selectedBarcode.example
        }

        self.generateRecaptchaToken()

        document.addEventListener("keydown", function (event) {
            if (event.key === "Escape") {
                self.closePopup()
            }
        })


    },
};
</script>